import type { FaireProductEntity } from "../../entity_types/product";

export const p_aystsqsqvk: FaireProductEntity = {
  token: "p_aystsqsqvk",
  type: "product",
  name: "9 PCS | Pickle Crack - Dill Pickle Hot Sauce",
  brandToken: "b_bvzjvsphbw",
  brandName: "Devil Daves Bloody Mary Co",
  imageUrl:
    "https://cdn.faire.com/fastly/9b4119e6a223b821e4463a75b13c437d8b57bdc97a777282db0467e60d8db798.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67e9161aa85762852571e6ae6e4a4377010ac33f7adf278dc748d0bb963cb9a9.jpeg",
    "https://cdn.faire.com/fastly/66470d46adff88695b4b16e795f331932d48654b57d074917d43748ebcf14334.jpeg",
    "https://cdn.faire.com/fastly/c60dfb137e8b3d6330734c06e945de971bbd8714587253762ec7e6ec06b68aa5.jpeg",
  ],
  priceDollars: 6.25,
  description:
    "Pickle Crack Hot Sauce - Wholesale\nUnleash the Flavor Explosion: Case of 9 - Zesty Bold and Tangy Hot Sauce\n\nIdeal for Retailers Seeking Unique, High-Demand Condiments\n\nExperience the perfect marriage of aged cayenne peppers and tangy pickle brine in Pickle Crack Hot Sauce. Crafted with the utmost care using only premium ingredients, including hand-selected half-sour dill pickles and a secret blend of exquisite herbs and spices. This isn't just hot sauce; it's a flavor adventure.\n\nWholesale Case of 9: Perfect for stocking your shelves with this fast-selling, customer-favorite product.\n10 OZ Big Bottle: Double the size of standard hot sauce bottles, offering exceptional value to your customers.\nGold Medal Quality: Winner of the prestigious 2023 Drunken Tomato Awards, ensuring top-tier taste and customer satisfaction.\nPremium Ingredients: No artificial flavors or fillers, just pure, authentic taste.\nConvenient Packaging: Easy-to-use Boston bottle with spout and cap for mess-free app.. ",
  tags: [],
  msrpDollars: 12.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:10.537Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
